import { ComponentChildren } from 'preact'
import { Dialog, DialogPanel } from '@headlessui/react'
import { clsx } from 'clsx'

import { Typography } from 'components/UI/atoms'

type Props = {
	bannerErrorMessage?: string
	children: ComponentChildren
	className?: string
	isOpen: boolean
	onCloseModal: () => void
}

const PreactDialog = Dialog as unknown as preact.FunctionComponent<{
	children: ComponentChildren
	as: string
	className: string
	onClose: (value: boolean) => void
	open?: boolean
	role?: 'dialog' | 'alertdialog'
	autoFocus?: boolean
	transition?: boolean
}>

const PreactDialogPanel = DialogPanel as unknown as preact.FunctionComponent<{
	children: ComponentChildren
	className: string
}>

const Modal = ({
	bannerErrorMessage,
	children,
	className,
	onCloseModal,
	isOpen
}: Props) => (
	<PreactDialog
		as='div'
		className='relative z-10 focus:outline-none'
		onClose={onCloseModal}
		open={isOpen}
	>
		<div className='fixed inset-0 bg-gray-800 bg-opacity-50 transition-opacity' />

		<div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
			<div className='flex min-h-full items-center justify-center p-4 text-center sm:p-0'>
				<PreactDialogPanel
					className={clsx(
						'relative rounded-lg border border-black-600 bg-black-900 text-left sm:w-full sm:max-w-lg',
						{ 'pb-20': bannerErrorMessage },
						className
					)}
				>
					{children}
					{bannerErrorMessage && (
						<div className='absolute bottom-0 left-0 w-full rounded-b-lg bg-error px-10 py-4'>
							<Typography
								text='Oops!'
								variant='label3'
								weight='font-semibold'
							/>{' '}
							<Typography
								text={bannerErrorMessage}
								variant='label3'
								weight='font-normal'
							/>
						</div>
					)}
				</PreactDialogPanel>
			</div>
		</div>
	</PreactDialog>
)

export { Modal }
